<template>
     <div style="width: 100%" class="mt-5">
          <v-layout row wrap>
               <div class="col-lg-12">
                    <div class="row">
                         <div class="col-lg-12 d-flex justify-end" v-if="!isAdmin">
                             <div class="d-flex align-center justify-center" style="padding-right: 12px; height: 100%;">
                                 <label style="margin-right: 8px;" class="v-label theme--light">{{$t('Chosen store')}}</label><v-switch dense inset @change="getStats()" v-model="selectedWebsite" color="#2F80ED" class="no-validation" style="padding-top: 0; margin-top: 0;" :label="$t('All stores')"></v-switch>
                             </div>
                         </div>

                        <div v-if="!isAdmin && stats"  class="col-12 col-sm-12 col-md-12 col-lg-7">
                            <v-card class="pa-4">
                                <v-card-title class="fw-600 fs-24">
                                    Sales Statistic
                                    <v-spacer></v-spacer>
                                    <span style="color: #828282;" class="fs-14 fw-500">{{dateFromChart}} - {{dateToChart}}</span>
                                </v-card-title>
                                <v-card-text>
                                    <div>
                                        <div  class="row mt-3">
                                            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-12 pr-0">
                                                <div>
                                                    <div class="d-flex align-center">
                                                        <v-img max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/wallet.svg')" contain></v-img>
                                                        <span class="ml-3 fs-16 fw-500" style="color: black;">Total Sales</span>
                                                    </div>
                                                    <div class="d-flex align-center">
                                                        <v-img style="visibility: hidden;" max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/wallet.svg')" contain></v-img>
                                                        <span class="ml-3 fs-36 fw-600" style="color: black;">{{ (stats.total).toFixed(2) }}</span><span class="ml-1 fs-14 fw-500" style="color: black;">AUD</span>
                                                    </div>
                                                </div>
                                                <div class="mt-5">
                                                    <div class="d-flex align-center">
                                                        <v-img max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/computer_sales.svg')" contain></v-img>
                                                        <span class="ml-3 fs-16 fw-500" style="color: black;">Products Sold</span>
                                                    </div>
                                                    <div class="d-flex align-center">
                                                        <v-img style="visibility: hidden;" max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/wallet.svg')" contain></v-img>
                                                        <span class="ml-3 fs-36 fw-600" style="color: black;">{{stats.totalItemsSold}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">/ {{ stats.thisMonthProductsSold }} this month</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pl-0 col-xs-12 col-sm-12  col-md-7 col-lg-7 col-12">
                                                <statystics-chart :currency="true" @input="activeType = $event" :activeType="activeType" :series-to-chart="series" :categories="categories" :chart="stats"></statystics-chart>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>
                        <div v-else-if="stats"  class="col-12 col-sm-12 col-md-12 col-lg-7">
                            <v-card class="pa-4">
                                <v-card-title class="fw-600 fs-24">
                                    Sales Statistic
                                    <v-spacer></v-spacer>
                                    <span style="color: #828282;" class="fs-14 fw-500">{{dateFromChart}} - {{dateToChart}}</span>
                                </v-card-title>
                                <v-card-text>
                                    <div class="row mt-3">
                                        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-12 pl-0 pr-0">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">Total Sales</span>
                                                </div>
                                                <div class="d-flex align-center mt-4">
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{ (stats.total).toFixed(2) }}</span><span class="ml-1 fs-14 fw-500" style="color: black;">AUD</span>
                                                </div>
                                                <div class="d-flex align-center mt-8">
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">Total outcome</span>
                                                </div>
                                                <div class="d-flex align-center mt-4">
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{ (stats.outcome).toFixed(2) }}</span><span class="ml-1 fs-14 fw-500" style="color: black;">AUD</span>
                                                </div>
                                            </div>
                                            <div class="mt-8">
                                                <div class="d-flex align-center">
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">Products Sold</span>
                                                </div>
                                                <div class="d-flex align-center mt-4">
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{stats.totalItemsSold}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">/ {{ stats.thisMonthProductsSold }} this month</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pl-0 col-xs-12 col-sm-12  col-md-7 col-lg-7 col-12">
                                            <statystics-chart :currency="true" @input="activeType = $event" :activeType="activeType" :series-to-chart="series" :categories="categories" :chart="stats"></statystics-chart>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-card class="mt-10 pa-4">
                                <v-card-title class="fw-600 fs-24">
                                    New users
                                    <v-spacer></v-spacer>
                                    <v-btn dense outlined color="blue" style="padding-top: 10px; padding-bottom: 10px;" >See all users</v-btn>

                                </v-card-title>
                                <v-card-text>
                                    <div class="row mt-3">
                                        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-12 pr-0 pl-0">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">All users</span>
                                                </div>
                                                <div class="d-flex align-center mt-4">
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{ stats.totalUsers }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-8">
                                                <div class="d-flex align-center">
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">New users</span>
                                                </div>
                                                <div class="d-flex align-center mt-4">
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{stats.newUsers}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">/ {{ stats.newUsersThisMonth }} this month</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pl-0 col-xs-12 col-sm-12  col-md-7 col-lg-7 col-12">
                                            <statystics-chart :currency="false" @input="activeType = $event" :activeType="activeType" :series-to-chart="userSeries" :categories="categories" :chart="stats"></statystics-chart>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>

                        <div v-if="!isAdmin && bestsellers" class="col-12 col-sm-12 col-md-12 col-lg-5">
                            <v-card>
                                <v-card-title>
                                    Products
                                    <v-spacer></v-spacer>
                                    <v-btn @click="$router.push('/products');" dense outlined color="blue" style="padding-top: 10px; padding-bottom: 10px;" >See all products</v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <div v-if="!isAdmin" class="row mt-3">
                                        <div class="col-md-7">
                                            <p class="ma-0 fw-600 fs-18">
                                                Bestsellers
                                            </p>
                                            <div class="mt-3 d-flex align-center" v-if="index < 3" v-for="(item,index) in bestsellers">
                                                <span  style="width: 10px;" class="fs-18 fw-500 mr-3">{{index+1}}</span>
                                                <v-img max-height="42px" max-width="42px" :src="$root.getSrc(item.photo ? item.photo : '/default/drop_icons/computer_product.svg')" contain></v-img>
                                                <div class="ml-3 d-flex justify-space-between flex-column">
                                                    <p class="ma-0 fw-600 fs-16 drop-blue">{{ item.name.slice(0,20) }}</p>
                                                    <p class="ma-0 fs-14 fw-400">Bought <span class="fw-600">{{item.quantity > 1 ? item.quantity + ' times' : 'once'}}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <v-img max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/computer_product.svg')" contain></v-img>
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">Products in shop</span>
                                                </div>
                                                <div class="d-flex align-center">
                                                    <v-img style="visibility: hidden;" max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/wallet.svg')" contain></v-img>
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{ stats.allProductsInStore }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-5">
                                                <div class="d-flex align-center">
                                                    <v-img max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/computer_plus.svg')" contain></v-img>
                                                    <span class="ml-3 fs-16 fw-500" style="color: black;">Newly Listed</span>
                                                </div>
                                                <div class="d-flex align-center">
                                                    <v-img style="visibility: hidden;" max-height="42px" max-width="42px" :src="$root.getSrc('/default/drop_icons/wallet.svg')" contain></v-img>
                                                    <span class="ml-3 fs-36 fw-600" style="color: black;">{{stats.newProducts}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">products</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="row mt-3">
                                        <div class="col-md-7">
                                            <p class="ma-0 fw-500 fs-18">
                                                Most used products
                                            </p>
                                            <div class="mt-3 d-flex align-center" v-if="index < 3" v-for="(item,index) in bestsellers">
                                                <span  style="width: 10px;" class="fs-18 fw-500 mr-3">{{index+1}}</span>
                                                <v-img max-height="42px" max-width="42px" :src="$root.getSrc(item.photo)" contain></v-img>
                                                <div class="ml-3 d-flex justify-space-between flex-column">
                                                    <p class="ma-0 fw-600 fs-16 drop-blue">{{ item.name.slice(0,20) }}</p>
                                                    <p class="ma-0 fs-14 fw-400">Bought <span class="fw-600">{{item.quantity > 1 ? item.quantity + ' times' : 'once'}}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <p class="ma-0 fw-500 fs-18">
                                                        Products in shop
                                                    </p>
                                                </div>
                                                <div class="mt-4 d-flex align-center">
                                                    <span class="fs-36 fw-600" style="color: black;">{{ stats.allProductsInStore }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-8">
                                                <div class="d-flex align-center">
                                                    <span class="fs-16 fw-500" style="color: black;">Newly listed</span>
                                                </div>
                                                <div class="mt-4 d-flex align-center">
                                                    <span class="fs-36 fw-600" style="color: black;">{{stats.newProducts}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">products</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>
                        <div v-else-if="bestsellers" class="col-12 col-sm-12 col-md-12 col-lg-5">
                            <v-card class="pa-4">
                                <v-card-title>
                                    Products
                                    <v-spacer></v-spacer>
                                    <v-btn @click="$router.push('/products');" dense outlined color="blue" style="padding-top: 10px; padding-bottom: 10px;" >See all products</v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <div class="row mt-3">
                                        <div class="col-md-7">
                                            <p class="ma-0 fw-600 fs-18">
                                                Most used products
                                            </p>
                                            <div class="mt-3 d-flex align-center" v-if="index < 3" v-for="(item,index) in bestsellers">
                                                <span  style="width: 10px;" class="fs-18 fw-500 mr-3">{{index+1}}</span>
                                                <v-img max-height="42px" max-width="42px" :src="$root.getSrc(item.photo)" contain></v-img>
                                                <div class="ml-3 d-flex justify-space-between flex-column">
                                                    <p class="ma-0 fw-600 fs-16 drop-blue">{{ item.name.slice(0,20) }}</p>
                                                    <p class="ma-0 fs-14 fw-400">Bought <span class="fw-600">{{item.quantity > 1 ? item.quantity + ' times' : 'once'}}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <p class="ma-0 fw-600 fs-18">
                                                        Products in shop
                                                    </p>
                                                </div>
                                                <div class="mt-4 d-flex align-center">
                                                    <span class="fs-36 fw-600" style="color: black;">{{ stats.allProductsInStore }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-8">
                                                <div class="d-flex align-center">
                                                    <span class="fs-16 fw-500" style="color: black;">Newly Listed</span>
                                                </div>
                                                <div class="mt-4 d-flex align-center">
                                                    <span class="fs-36 fw-600" style="color: black;">{{stats.newProducts}}</span><span class="ml-1 fs-14 fw-500" style="color: black;">products</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-card class="mt-10 pa-4">
                                <v-card-title>
                                    Most selling stores
                                    <v-spacer></v-spacer>
                                    <v-btn @click="$router.push('/products');" dense outlined color="blue" style="padding-top: 10px; padding-bottom: 10px;" >See all stores</v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <div class="row mt-3">
                                        <div class="col-md-5">
                                            <div class="mt-3 d-flex flex-column" v-if="index < 5" v-for="(item,index) in mostOrders">
                                                <div class="mt-3 d-flex align-center">
                                                    <span style="width: 24px; height: 24px; border-radius: 8px;" :style="{'background': colors[index]}" class="mr-3"></span>
                                                    <p class="ma-0 fw-500 fs-16">{{ item.name }}</p>
                                                </div>
                                                <div class="mt-4 ml-10">
                                                    <p class="ma-0 fw-600 fs-36">{{parseFloat(item.percentage).toFixed(2)}}%</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-7 d-flex justify-center align-center">
                                            <div class="pl-0">
                                                <statistics-pie chartType="pie" @input="activeType = $event" :activeType="activeType" :series-to-chart="orderSeries" :categories="categories" :chart="stats"></statistics-pie>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>


                        <div class="col-md-12 col-12" v-if="lastOrders">
                            <v-card class="pa-4">
                                <v-card-title>
                                    Orders
                                    <v-spacer></v-spacer>
                                    <v-btn @click="$router.push('/orders');" dense outlined color="blue" style="padding-top: 10px; padding-bottom: 10px;" >Go to orders</v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <div class="row">
                                        <div class="header-center-align pt-5 w-100">
                                            <v-data-table
                                                class="order-table"
                                                :loading="load"
                                                :items="lastOrders"
                                                :headers="isAdmin ? orderAdminHeaders : orderHeaders"
                                                :hide-default-footer="true"
                                            >
                                                <template v-slot:item.id="{item}">
                                                    #{{item.id}}
                                                </template>
                                                <template v-slot:item.store_name="{item}">
                                                    {{item.website.name}}
                                                </template>


                                                <template v-slot:item.created_at="{item}">
                                                    {{getDate(item.created_at)}}
                                                </template>
                                                <template v-slot:item.status="{item}">
                                                   {{item.status}}
                                                </template>
                                                <template v-slot:item.buyer="{item}">
                                                   {{item.address.name}}
                                                </template>
                                                <template v-slot:item.products="{item}">
                                                    <v-img max-width="48px" max-height="48px" :src="product.preview_photos.length > 0 ? $root.getSrc(product.preview_photos[0]) : null" v-for="product in item.items"></v-img>
                                                </template>
                                                <template v-slot:item.price="{item}">
                                                    {{ (parseFloat(item.amount_for_website) + parseFloat(item.production_amount)).toFixed(2) }}&nbsp;AUD
                                                </template>
                                                <template v-slot:item.profit="{item}">
                                                    {{ parseFloat(item.amount_for_website).toFixed(2) }}&nbsp;AUD
                                                </template>
                                                <template v-slot:item.amount="{item}">
                                                    {{ parseFloat(item.amount).toFixed(2) }}&nbsp;AUD
                                                </template>
                                                <template v-slot:item.status="{item}">
                                                    <span style="border-radius: 8px; padding: 4px 8px;" :class="item.status">
                                                         {{ getStatus(item.status) }}
                                                    </span>
                                                </template>

                                                <template v-slot:item.actions="{item}">
                                                    <div class="d-flex justify-space-between align-center flex-row">
                                                        <router-link :to="'/orders/'+item.hash"><v-img  class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/edit_pencil.svg')"></v-img></router-link>
                                                        <v-img @click="changeHrefTo(item.link)" class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/eye.svg')"></v-img>
                                                        <v-img @click="deleteOrder(item.id)" class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/trash.svg')"></v-img>
                                                    </div>
                                                </template>


                                            </v-data-table>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>

                    </div>
               </div>
          </v-layout>
     </div>
</template>
<style>
.v-banner__text {
    width: 100%
}
</style>
<script>
import {getChartLastOrders, getChartStats} from "../api/user";


const StatysticsChart = () => ({
     component: import('./home/statystics-chart.vue'),
     timeout: 3000
})
const StatisticsPie = () => ({
    component: import('./home/statistics-pie.vue'),
    timeout: 3000
})
export default {
     components:{
           StatysticsChart, StatisticsPie
     },
     data(){
          return{
               selectedWebsite: true,
               stats: null,
               onlyChart: 0,
               activeType:'all',
               news:null,
              currentDate: 'all',
              dateFrom: null,
              dateFromChart: null,
              dateTo: null,
              dateToChart: null,
              lastOrders: null,
              clickedButton: false,
              colors: ['#D72C83', '#2F80ED', '#FFC700', '#676767', '#775dd0'],
              headers:[
                  {
                      text: 'Store',
                      value: 'name',
                      sortable: false,
                      width: '80px'
                  },
                  {
                      text: 'Amount of orders',
                      value: 'amount',
                      sortable: false,
                      width: '150px'
                  },
                  {
                      text: 'Store margin',
                      value: 'margin',
                      sortable:false,
                      width: '150px'
                  },
                  {
                      text: 'Total',
                      value: 'total',
                      sortable:false,
                      width: '150px'
                  }
              ],
              orderHeaders:[
                  {
                      text: 'Order ID',
                      value: 'id',
                      align: 'left'
                  },
                  {
                      text: 'Date',
                      value: 'created_at',
                      align: 'left'
                  },
                  {
                      text: 'Customer',
                      value: 'buyer',
                      align: 'left'
                  },
                  {
                      text: 'Products',
                      value: 'products',
                      align: 'left'
                  },
                  {
                      text: 'Price',
                      value: 'price',
                      align: 'left'
                  },
                  {
                      text: 'Your profit',
                      value: 'profit',
                      align: 'left'
                  },
                  {
                      text: 'Status',
                      value: 'status',
                      align: 'center'
                  },
              ],
              orderAdminHeaders:[
                  {
                      text: 'ID',
                      value: 'id',
                      align: 'left'
                  },
                  {
                      text: 'Store name',
                      value: 'store_name',
                      align: 'left'
                  },
                  {
                      text: 'Buyer',
                      value: 'buyer',
                      align: 'left'
                  },
                  {
                      text: 'Email',
                      value: 'email',
                      align: 'left'
                  },
                  {
                      text: 'Created',
                      value: 'created_at',
                      align: 'left'
                  },
                  {
                      text: 'Total',
                      value: 'amount',
                      align: 'left'
                  },
                  {
                      text: 'Status',
                      value: 'status',
                      align: 'left'
                  },
                  {
                      text: '',
                      value: 'actions',
                      align: 'left'
                  },
              ],
              filterStatus: null,
              bestsellers: null,
              series: [],
              userSeries: [],
              categories: [],
              load: true,
              mostOrders: [],
              orderSeries: [],
              displayOther: false
          }
     },
     watch:{
         filterStatus: function(){
             this.getStats();
         },
          activeType: function () {
               this.onlyChart = 1;
               this.getStats();
          },
     },
     computed:{
          earnings(){
              if(!this.stats.earnings) return 0;
              var data = this.$options.filters.currency(this.stats.earnings);
              data = data.toString();
              return '$'+data;
          },
          websites(){
              let websites = [];
              let userId = this.$store.getters.user.id;
              this.$store.getters.websites.forEach(website=>{
                  if(website.user_id === userId) {
                      websites.push(website)
                  } else {
                      this.$store.getters.user.website_permissions.forEach(permission=>{
                          if(permission.type==='browse_dashboard' && permission.user_permission.website_id === website.id && permission.value===1) websites.push(website);
                      })
                  }
              })
              return websites;
          },
          income(){
               if(!this.stats.income) return 0;
               var data = this.$options.filters.currency(this.stats.income);
               data = data.toString();
               return '$'+data;
          },
          user(){
               return this.$store.getters.user;
          },
         filterStatuses(){
             return this.$store.getters.statuses
         },
         isAdmin(){
             return this.$store.getters.user.website_role.name == 'admin' ? true : false;
         }
     },
    mounted() {
        this.getStats();
        this.getLastOrders();
    },
     methods:{
         getLastOrders(){
             getChartLastOrders().then(res=>{
                 this.lastOrders = res;
             })
         },
         changeHrefTo(link){
             location.href = link;
         },
         deleteOrder(id){
             this.$confirm(this.$t('Delete order'), this.$t('Are you sure? This action will delete selected order.'), {cancel:{text:'No', color:'gray'}, accept:{text:'Yes', color:'red'}}).then(res => {
                 // deleteOrders(ids).then(response => {
                 //     this.$store.commit('app/ADD_MESSAGE', {text: ids.length==1 ? 'Product successfully deleted!':'Products successfully deleted!', type:'success'});
                 //     this.getData();
                 // }).catch(e => {
                 //     this.$store.commit('app/ADD_MESSAGE', {text: 'Error '+e.response.data.message, type:'error'});
                 // })
             })
         },
         getStatus(status){
             return status == 'new' ? 'New order': (status == 'sent' ? 'Delivery' : (status == 'in_progress' ? 'In production' : (status == 'canceled' ? 'Canceled' : 'On hold')));
         },
         getDate(date){
             var today = new Date(date);
             var dd = String(today.getDate()).padStart(2, '0');
             var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
             var yyyy = today.getFullYear();
             let minutes = today.getMinutes();
             if(minutes<10) minutes = '0'+minutes;
             return this.isAdmin ? dd+'/'+mm+'/'+yyyy+' '+today.getHours()+':'+minutes : dd+'.'+mm+'.'+yyyy+', '+today.getHours()+':'+minutes;
         },
         getStats(){
             let id = null;
             if(!this.selectedWebsite){
                 id = this.$store.getters.activeWebsite.id;
             }

             var date = new Date();
             let firstday = date.getFullYear()+'-01-01';
             this.dateFrom = firstday;
             this.dateFromChart = '01.'+date.getFullYear();
             let lastday = date.getFullYear()+'-12-'+this.daysInMonth(11,date.getFullYear());
             this.dateTo = lastday;
             this.dateToChart = '12.'+date.getFullYear();
             getChartStats({from: this.dateFrom, to: this.dateTo, filterWebsites: id, status: this.filterStatus, isAdmin: this.isAdmin}).then(response => {
                 this.stats = response;
                 this.load = false
                 var sortable = [];
                 for (var item in this.stats.itemsSold) {
                     let obj = {
                         name: item,
                         quantity: this.stats.itemsSold[item].quantity,
                         photo:  this.stats.itemsSold[item].photo
                     }
                     sortable.push(obj);
                 }
                 sortable.sort((a, b) => (a.quantity < b.quantity) ? 1 : -1);

                 this.bestsellers = sortable;
                 for(let key in this.stats.monthSales){
                     if (this.stats.monthSales.hasOwnProperty(key)) {
                         this.series.push(this.stats.monthSales[key].toFixed(2))
                         this.categories.push(key);
                     }
                 }

                 for(let key in this.stats.userCreation){
                     if (this.stats.userCreation.hasOwnProperty(key)) {
                         this.userSeries.push(this.stats.userCreation[key])
                     }
                 }

                 let orders = [];
                 let totalOrders = 0;


                 for (const [key, value] of Object.entries(this.stats.mostSellingStores)) {
                     let obj = {
                         name: key,
                         quantity: value
                     }
                     totalOrders += obj.quantity;
                     orders.push(obj);
                 }

                 orders.sort((a, b) => (a.quantity < b.quantity) ? 1 : -1);
                 if(orders.length > 5){
                     let otherPercentage = 0;
                     let newOrders = [];
                     orders.forEach((website, index)=>{
                         website.percentage = ((website.quantity/totalOrders)*100).toFixed(2);
                         if(index < 4){
                             newOrders.push(website);
                             this.orderSeries.push(parseFloat(website.percentage));
                         } else {
                             otherPercentage+=parseFloat(website.percentage);
                         }
                     })
                     let obj = {
                         name: 'Other',
                         percentage: otherPercentage
                     }
                     newOrders.push(obj);
                     orders = newOrders;
                     this.orderSeries.push(parseFloat(otherPercentage));
                 } else {
                     orders.forEach(website=>{
                         website.percentage = ((website.quantity/totalOrders)*100).toFixed(2);
                         this.orderSeries.push(parseFloat(website.percentage));
                     })
                 }

                 this.mostOrders = orders;

             }).catch(e => {
                 console.log(e)
                 // this.$store.commit('app/ADD_MESSAGE', {text: "We couldn't get statistics", type: 'error'});
             })
         },
         goTo(url){
             this.$router.push(url);
         },
         daysInMonth (month, year) {
             return new Date(year, month+1, 0).getDate();
         },
         getDateToDisplay(date){
             let dd = String(date.getDate()).padStart(2, '0');
             let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
             let yyyy = date.getFullYear();
             return  yyyy+'-'+mm+'-'+dd;
         },
         getDateToDisplayOnChart(date){
             let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
             let yyyy = date.getFullYear();
             return mm+'.'+yyyy;
         }
     }
};
</script>
<style>
.order-table td {
    font-weight: 400!important;
}
</style>
